import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import { Box } from '@material-ui/core';
import { classNames } from '../../../../../../utils';
import { i18n } from '../../../../../../language';

const useStyles = makeStyles((theme) => ({
  popver: {
    '& .MuiPaper-root': {
      overflow: 'auto',
      backgroundColor: 'transparent',
      boxShadow: 'unset',
      borderRadius: '0 !important',
      border: '0',
      padding: '0',
      marginTop: '-2rem',
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    width: '18rem',
    height: '13.063rem',
    borderRadius: '0.168rem',
    boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    backgroundColor: '#fff',
    marginRight: '0.9rem',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '1.8rem',
      right: '0',
      transform: 'translate(105%, 5.5rem)',
      borderLeft: '0.9rem solid rgba(0, 0, 0, 0.1)',
      borderBottom: '1.2rem solid transparent',
      borderTop: '1.2rem solid transparent',
    },
  },
  selectTime: {
    flexBasis: '2.5rem',
    backgroundColor: '#f5faff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#7d86a9',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '1.25rem',
    flex: '0 0',
  },
  triangleIcon: {
    position: 'absolute',
    top: '1.8rem',
    right: '0',
    transform: 'translate(95%, 5.5rem)',
    borderLeft: '0.9rem solid #fff',
    borderBottom: '1.2rem solid transparent',
    borderTop: '1.2rem solid transparent',
  },
}));

export default function AddRemarksPop({ id, closePop, anchorEl, children, className }) {
  const classes = useStyles();

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={closePop}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'right',
      }}
      className={classes.popver}
    >
      <div className={classNames(classes.root, className)} id={id}>
        <Typography className={classes.selectTime}>{i18n.t('BEDSTATUS_SELECT_REMARKS')}</Typography>
        <Box overflow="auto" display="flex" flexDirection="column">
          {children}
        </Box>
        <div className={classes.triangleIcon} />
      </div>
    </Popover>
  );
}
